import { render, staticRenderFns } from "./EntityEditSection.vue?vue&type=template&id=47956614"
import script from "./EntityEditSection.vue?vue&type=script&lang=js"
export * from "./EntityEditSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports